<template>
  <div
    @mouseover="setHover(true)"
    @mouseleave="setHover(false)"
    @click="toggleOrder()"
  >
    <span>{{ header.text }} </span>
    <v-icon
      v-if="canOrderBy"
      class="orderArrow"
      :class="arrowClasses"
      small
    >
      arrow_upward
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'DataTableHeaderCell',
  props: {
    header: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    hover: false,
    orderBy: null,
  }),
  computed: {
    arrowClasses() {
      return {
        inHover: this.hover && !this.orderBy,
        arrowUp: this.orderBy === 'asc',
        arrowDown: this.orderBy === 'desc',
      };
    },
    canOrderBy() {
      return this.header.orderBy;
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(value) {
        const { sortBy, orderBy } = value;
        this.orderBy = null;
        if (sortBy === this.header.orderBy) {
          this.orderBy = orderBy;
        }
      },
    },
  },
  methods: {
    setHover(status) {
      this.hover = status;
    },
    toggleOrder() {
      if (!this.canOrderBy) {
        return;
      }

      let nextOrder = null;
      if (this.orderBy === null) {
        nextOrder = 'asc';
      }

      if (this.orderBy === 'asc') {
        nextOrder = 'desc';
      }

      if (this.orderBy === 'desc') {
        nextOrder = null;
      }

      this.orderBy = nextOrder;

      this.$emit('update-order', { column: this.header.orderBy, orderBy: this.orderBy });
    },
  },
};
</script>

<style lang="stylus">
.orderArrow
  opacity 0

.inHover
  opacity 0.6

.arrowUp
  opacity 1

.arrowDown
  opacity 1
  transform rotate(180deg)

</style>
